export default __webpack_public_path__ + "images/AP.04a31b5.png";